<template>
  <el-dialog
  :title="popTitle"
  :visible.sync="visibleDialog"
  width="650px"
  top="calc(50vh - 200px)"
  class="pop-dialog pop-submit-apply"
  append-to-body>
  <!-- 提成类型：1-首购，2-复购提成类型 -->
  <!-- 首 变 复  -->
   <div v-if="bonusType==1" class="apply-form">
      <div>
        <div class="lable">系统判断当前订单的提成类型为<span class="danger">首购提成</span>，若您认为是<span class="danger">复购提成</span>请上传证据。</div>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="上传图片证据" prop="fileUrls" class='form-item-images' style="line-height: 1;">
          <div class="info">（图片最多不超过6张，每张大小不超2M，图片格式支持jpg，jpeg，bmp）</div>
          <upload-picture :limit="6" :list="form.fileUrls" @changeImage="changeImage"  class="upload-list" />
        </el-form-item>
        <el-form-item :label="reasonText" class="form-item-reason">
          <el-input maxlength="64" :rows="3" show-word-limit placeholder="请输入备注" type="textarea" class="textarea" v-model="form.reason"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 复 变 首  -->
    <div v-else-if="bonusType == 2"  class="apply-form">
      <el-form ref="form" :model="form">
        <div class="lable">系统判断当前订单的提成类型为<span class="danger">复购提成</span>，请确认是否修改为<span class="danger">首购提成</span>。</div>
      </el-form>
    </div>
  <template slot="footer">
    <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
    <el-button type="primary" @click="onConfirm" size="mini" :loading="btnLoading">确 定</el-button>
  </template>
</el-dialog>
</template>
<script>
import uploadPicture from '@/components/upload/pictureList.vue'
  export default {
    name:'popSubmitApply',
    components: {
      uploadPicture
    },
    data () {
      return {
        visibleDialog:false,
        btnLoading:false,
        popTitle:'',
        reasonText:'',
        orderId:'',
        orderNo:'',
        bonusType:'',
        type:'',
        form: {
          fileUrls: [],
          reason: ''
        },
        rules: {
          fileUrls: [{ type: 'array', required: true, message: '上传图片证据', trigger: 'change' }],
        }
      }
    },
    methods: {
      show(item) {
        this.form.fileUrls = []
        this.form.reason = ''
        this.orderId = item.id
        this.orderNo = item.orderNo
        this.bonusType = item.bonusType
        this.type = item.type
        if (this.type=='editApply') {
          this.popTitle = '发起修改提成'
          this.reasonText = '修改备注'
        }else  if (this.type=='submitApply'){
          this.popTitle = '发起提成申诉'
          this.reasonText = '申诉备注'
        }
        
        this.visibleDialog = true
        console.log('show>>',item,this.orderId,this.bonusType)
      },
      // 获取上传图片文件的链接
    changeImage(val) {
      console.log(val)
      this.form.fileUrls = val
    },
    getImagesUrl(code) {
      const url = this.ImgHttps + code
      this.form.fileUrls.push(url)
      console.log('getImagesUrl', this.form)
    },
    removeImagesUrl(url) {
      console.log('removeImagesUrl', url)
      const delIndex = this.form.fileUrls.findIndex(e => { return e === url })
      this.form.fileUrls.splice(delIndex, 1)
    },
    // 确认修改
    onConfirm() {
      this.$refs.form.validate((valid) => {
      if (valid) {
        let newBonusType = this.bonusType == 1? 2:1
        let postData = {
            bonusType:newBonusType,
            reason:this.form.reason
          }
        let APIURL,message
        if (this.type=='editApply') {
          APIURL = 'omsModifyApply'
          message = '已发起修改提成'
          postData.orderNo = this.orderNo
        }else  if (this.type=='submitApply'){
          APIURL = 'omsSubmitApply'
          message = '已发起提成申诉'
          const urls = this.form.fileUrls.map(e => e.url)
          postData.orderId = this.orderId
          postData.fileUrls = urls.join(',')
        }
        this.btnLoading = true
        this.$api[APIURL](postData).then(res => { 
          if (res.code === 0) {
              this.$message.success(message)
              this.$emit('fetchData')
            }
        }).finally(() => {
          this.btnLoading = false
          this.visibleDialog = false
        })
        }
      })
    },
    },
  }
</script>
<style lang='scss'>
.pop-submit-apply{
  .apply-form{
    padding-top: 20px;
    .form-item-images{
      margin-bottom: 13px;
      .info{
        line-height: 40px;
      }
      .el-form-item__content{
        line-height: 1;
      }
    }
    .form-item-reason{
      margin-bottom: 0;
    }
    .textarea{
      font-size: 12px;
    }
  }
   .el-upload--picture-card {
      width: 128px;
      height: 128px;
      line-height: 128px;
      border-radius: 0;
      background-color: #fff;
      border: 1px dashed #D9D9D9;
      margin-bottom: 7px;
  }
  .el-form-item__error{
    padding-top: 0;
    margin-top: -3px;
  }
}
</style>